export default __webpack_public_path__ + "static/media/0xc3ec80343d2bae2f8e680fdadde7c17e71e114ea.0ebb6f08.webp";